import React from 'react'
// import { RouteComponentProps } from 'react-router-dom'
import HomePageLayout from 'Pages/Layout/PageLayout'
import { connect } from 'react-redux'
import { userTokenSelector } from 'Store/customer/selector'
import { RootState } from 'Store'
import { Col, Row } from 'antd'
import { Income, TimeSale, TopProduct } from './components'
import { selectEventDashboard, selectOrderDashboardEvent } from 'Store/dashboard/selector'
import { LoadingView } from 'Components/modal'

type Props = {} & ReduxProps

const Dashboard: React.FunctionComponent<Props> = props => {
  const { event, orderEvent } = props
  return (
    <HomePageLayout selected="dashboard" title="แดชบอร์ด">
      <LoadingView isShow={event.IsLoading || orderEvent?.IsLoading} />
      <Row gutter={[16, 48]}>
        <Col span={24}>
          <Income />
        </Col>
        <Col span={24}>
          <TimeSale />
        </Col>
        <Col span={24}>
          <TopProduct />
        </Col>
      </Row>
    </HomePageLayout>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    token: userTokenSelector(state),
    event: selectEventDashboard(state),
    orderEvent: selectOrderDashboardEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(Dashboard)
